
import { defineComponent, ref, watch } from 'vue'
import { gsap, Power1 } from 'gsap'

export default defineComponent({
  props: {
    delay: Number,
    lottery: {
      type: Number,
      required: true
    }
  },

  emits: ['finish'],

  setup (props, { emit }) {
    const lotteryStart = ref(false)
    const lotteryProgress = ref(false)
    const lotteryEnd = ref(false)

    const lotteryFinish = ref(0)

    const prevLottery = ref(0)

    const tigerMachineLotteryGroupRef = ref()

    function startLottery () {
      console.log('startLottery')
      // lotteryEnd.value = false
      // lotteryStart.value = true

      // setTimeout(() => {
      //   lotteryStart.value = false
      //   lotteryProgress.value = true

      //   setTimeout(() => {
      //     lotteryProgress.value = false
      //     lotteryEnd.value = true
      //   }, 960)
      // }, 1500)

      // gsap.to(tigerMachineLotteryGroupRef.value, { yPercent: -40, duration: 10 })

      gsap.fromTo(
        tigerMachineLotteryGroupRef.value,
        { yPercent: prevLottery.value ? -10 * (prevLottery.value - 1) : 0 },
        { yPercent: -90, duration: 1.5, ease: Power1.easeIn }
      )

      const tl = gsap.timeline({ repeat: 5, delay: 1.5 })

      tl.fromTo(
        tigerMachineLotteryGroupRef.value,
        { yPercent: 0 },
        { yPercent: -50, duration: 0.24, ease: 'none' }
      )

      gsap.to(tigerMachineLotteryGroupRef.value, {
        yPercent: -10 * props.lottery - 40,
        duration: 1.5,
        delay: 1.5 + 5 * 0.24,
        onComplete: animationend
      })
    }

    function animationend () {
      console.log('animationend')

      // if (lotteryEnd.value) {
      //   lotteryEnd.value = false

      //   lotteryFinish.value = props.lottery * 10 - 10

      //   emit('finish')
      // }
      prevLottery.value = props.lottery

      emit('finish')
    }

    watch(
      () => props.lottery,
      () => {
        console.log(props.lottery)

        if (!props.delay) {
          return startLottery()
        }

        setTimeout(() => {
          startLottery()
        }, props.delay)
      }
    )

    return {
      tigerMachineLotteryGroupRef,
      lotteryStart,
      lotteryProgress,
      lotteryEnd,
      lotteryFinish,
      animationend
    }
  }
})
